module.exports = __webpack_public_path__ + "static/media/mira-technology-park-plug-and-play.b1ed4249.jpg";